var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.toast.open)?_c('div',{staticClass:"toast",on:{"click":_vm.close}},[_c('img',{attrs:{"src":"/images/icons/toast.svg","alt":""}}),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.$store.state.toast.message)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff328784","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Toast.vue
// module id = HrsA
// module chunks = 1